const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview"
import UserDataManager from "../../../../manager/user_manager";
import ModelData, { IUserData } from '../../../public/model_data';
import Uitl from "../util"
import GameUtil from "../../../../utility/game_util"

@ccclass
export default abstract class PlayerListView extends ViewBase {

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;



    m_list: ListView = null

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 1,
            gap_y: 10,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
        


    }
    
    on_item_select(data: any, index: number) {
        //LogManager.log(data, index);
    }


    updateShow(m_Data){
        this.m_list.set_data(m_Data);
        this.m_list.select_item(10)
        this.m_list.scroll_to(0)
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let indexLab = cc.find("IndexBg/RankIndex", item).getComponent(cc.Label)
        let indexBg = cc.find("IndexBg", item).getComponent(cc.Sprite)
        let bg = cc.find("Bg", item).getComponent(cc.Sprite)
        let name = cc.find("Name", item).getComponent(cc.Label)
        let count = cc.find("Count", item).getComponent(cc.Label)
        let icon = cc.find("Avatar/Mask/SpriteAvatar", item).getComponent(cc.Sprite)
        let zhuLab = cc.find("Zhu/Count", item).getComponent(cc.Label)
        let yinLab = cc.find("Yin/Count", item).getComponent(cc.Label)
        count.string = GameUtil.currencyFormatting(Number(data.balance))
        indexLab.string = (index + 1).toString()
        name.string = ""
        icon.node.active = false
        UserDataManager.setUserJsonData(data.userData)
        this.getUserData(data.id, (palyerData : IUserData)=> {
            name.string =  GameUtil.cutStr(palyerData.name) 
            icon.spriteFrame = palyerData.avatarSprite
            icon.node.active = true

        })
        zhuLab.string = GameUtil.currencyFormatting(Number(data.betAmount))
        yinLab.string = data.winCount + "%"
    }
}